/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import LeadPreview from 'DesignSystem/LeadPreview/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile/Lead/Content",
  handleClose
  
}) {
let personLeadIdValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'leadId',
})
  return (<React.Fragment
>
<LeadPreview
  viewPath={`${viewPath}/LeadPreview`}
 data="person.leadId"
 leadId={personLeadIdValueData}
 showNextActions={false}
 handleClose={handleClose}
/>
{children}
</React.Fragment>)
}